<template>
  <div class="pcenter" style="margin-top: 30px;">
    <div :span="24" style="flex-flow: column;" class="pcenter">
      <div><span style="font-size:16px; font-weight: bold;">选择升级的账号类型</span></div>
      <div class="pcenter" style="margin-top: 20px; flex-wrap: wrap;">
        <div class="pcenter" style="padding: 10px;" @click="selperson">
          <div style="width:300px; height:120px; border: 1px #ccc solid; padding: 20px; flex-flow: column;">
            <div class="pcenter"><el-button type="primary" icon="el-icon-edit" circle></el-button><span style="font-size:16px; margin-left: 10px;">个人专业版</span></div>
            <div style="margin-top: 10px;"><span style="color: #ccc;">适合于个人用户，适合小范围独立运营</span></div>
          </div>
        </div>
        <div class="pcenter" style="padding: 10px;" @click="selcus">
          <div style="width:300px; height:120px; border: 1px #ccc solid; padding: 20px; flex-flow: column;">
            <div class="pcenter"><el-button type="primary" icon="el-icon-edit" circle></el-button><span style="font-size:16px; margin-left: 10px;">企业版</span></div>
            <div style="margin-top: 10px;"><span style="color: #ccc;">适合于企业用户，全面开放所有功能</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  export default {
    name: 'SelUpWay',
    methods: {
      selperson () {
        localStorage.setItem('upway','person')
        this.$emit('s_person');
      },
      selcus () {
        localStorage.setItem('upway','cus')
        this.$emit('s_cus');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/SelUpWay.vue